import React from 'react'
import './style.css'

const ChatbotIntigratedSection = ({ content }) => {
    return (
        <>
            <section className="chatbot-intigrated-section-box">
                <div className="container text-center">
                    <div className="chatbot-intigrated-section-box-header">
                        <h2 className="chatbot-intigrated-section-box-main-title">Integrate Once. <span>Connect Everywhere</span></h2>
                        <p className="description-text">Reach customers seamlessly through your website & every major communication channel.</p>
                    </div>
                    <div className="chatbot-intigrated-section-box-hero-animation">
                        <div className="chatbot-intigrated-section-box-orbit" />
                        <div className="chatbot-intigrated-section-box-float-icon chatbot-intigrated-section-box-icon-1">
                            <img src="/images/social-icons/whatsapp.png" alt="WhatsApp chatbot support" />
                        </div>
                        <div className="chatbot-intigrated-section-box-float-icon chatbot-intigrated-section-box-icon-2">
                            <img src="/images/social-icons/discord.png" alt="Discord chatbot builder" />
                        </div>
                        <div className="chatbot-intigrated-section-box-float-icon chatbot-intigrated-section-box-icon-3">
                            <img src="/images/social-icons/slack.png" alt="Slack chatbot integration" />
                        </div>
                        <div className="chatbot-intigrated-section-box-float-icon chatbot-intigrated-section-box-icon-5">
                            <img src="/images/social-icons/telegram.png" alt="Telegram chatbot development" />
                        </div>
                        <div className="chatbot-intigrated-section-box-float-icon chatbot-intigrated-section-box-icon-6">
                            <img src="/images/social-icons/chat.png" alt="Build chatbot for WeChat" />
                        </div>

                        <div className="chatbot-intigrated-section-box-float-icon chatbot-intigrated-section-box-icon-7">
                            <img src="/images/social-icons/instagram.png" alt="Instagram chatbot integration" />
                        </div>

                        <div className="chatbot-intigrated-section-box-float-icon chatbot-intigrated-section-box-icon-8">
                            <img src="/images/social-icons/viber.png" alt="Viber chatbot service" />
                        </div>

                        <div className="chatbot-intigrated-section-box-float-icon chatbot-intigrated-section-box-icon-9">
                            <img src="/images/social-icons/line.png" alt="LINE chatbot connection" />
                        </div>

                        <div className="chatbot-intigrated-section-box-float-icon chatbot-intigrated-section-box-icon-10">
                            <img src="/images/social-icons/messenger.png" alt="messenger" />
                        </div>

                        <div className="chatbot-intigrated-section-box-center-icon">
                            <svg width={100} height={100} viewBox="0 0 24 24" alt="Multi-channel chatbot development" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 10H19C20.1046 10 21 10.8954 21 12V13C21 14.1046 20.1046 15 19 15H18V10Z" fill="white" />
                                <path d="M6 10H5C3.89543 10 3 10.8954 3 12V13C3 14.1046 3.89543 15 5 15H6V10Z" fill="white" />
                                <path fillRule="evenodd" clipRule="evenodd" d="M12 4C8.68629 4 6 6.68629 6 10V16C6 17.6569 7.34315 19 9 19H15C16.6569 19 18 17.6569 18 16V10C18 6.68629 15.3137 4 12 4ZM10.5 11.25C10.5 10.8358 10.1642 10.5 9.75 10.5C9.33579 10.5 9 10.8358 9 11.25V12.75C9 13.1642 9.33579 13.5 9.75 13.5C10.1642 13.5 10.5 13.1642 10.5 12.75V11.25ZM15 11.25C15 10.8358 14.6642 10.5 14.25 10.5C13.8358 10.5 13.5 10.8358 13.5 11.25V12.75C13.5 13.1642 13.8358 13.5 14.25 13.5C14.6642 13.5 15 13.1642 15 12.75V11.25Z" fill="white" />
                            </svg>
                        </div>
                    </div>
                    <div className="row g-4 justify-content-center">
                        {content?.map((item, index) => {
                            return <div className="col-lg-4 col-md-6" key={index}>
                                <div className="chatbot-intigrated-section-box-card">
                                    <div className="combine-heading-and-icon">
                                        <div className="chatbot-intigrated-section-box-card-icon"><img src={item?.icon} alt="" /></div>
                                        <h3 className="chatbot-intigrated-section-box-card-title">{item?.title}</h3>
                                    </div>
                                    <p className="chatbot-intigrated-section-box-card-content description-text">{item?.description}</p>

                                    {item?.socialIcons && <div className="social-icons-image-chatbot-intigrated-section-box-card">
                                        {item?.socialIcons?.map((icon, index) => {
                                            return <img key={index} src={icon.image} width={icon?.width} alt={icon?.title} />
                                        })}
                                    </div>}
                                </div>
                            </div>
                        })}
                    </div>
                </div>
            </section>
        </>
    )
}

export default ChatbotIntigratedSection